module.exports = __webpack_public_path__ + "static/Cel2PR-05beabff6107914e50269e295107dcdb.mp4";